var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageColumn',{scopedSlots:_vm._u([{key:"empty-state-panel",fn:function(){return [_c('LayoutFillPageWithEmptyState',{staticClass:"text-sm",attrs:{"forName":" Session "}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }